import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import React from 'react'
import TemplateLists from './TemplateLists'
import NewTemplateLists from './NewTemplateLists'
import SpineNewTemplateLists from './SpineNewTemplateLists'
import FrameRankingLists from './FrameRankingLists'
import AvatarRedisLists from './AvatarRedisLists'
import { useTabQuery } from 'hooks/useQueryState'

const Index = () => {
  const [tab, setTab] = useTabQuery('templateListTab', 'new')

  return (
    <>
      <div className="flex-1 space-y-4">
        <div className="flex items-center justify-between space-y-2">
          <h2 className="text-3xl font-bold tracking-tight">Template Lists</h2>
        </div>
        <Tabs value={tab} onValueChange={setTab} className="space-y-4">
          <TabsList className="inline-flex h-auto w-auto flex-wrap justify-start">
            <TabsTrigger value="new">New</TabsTrigger>
            <TabsTrigger value="spineNew">Spine New</TabsTrigger>
            <TabsTrigger value="daily">frame daily reCreate</TabsTrigger>
            <TabsTrigger value="total">frame total reCreate</TabsTrigger>
            <TabsTrigger value="avatarNew">Avatar New</TabsTrigger>
            <TabsTrigger value="avatarDaily">Avatar daily</TabsTrigger>
            <TabsTrigger value="avatarSimple">Avatar simple</TabsTrigger>
            <TabsTrigger value="spine">Tag Spine</TabsTrigger>
            <TabsTrigger value="christmas">Tag Christmas</TabsTrigger>
            <TabsTrigger value="outfit">Templates with Sets</TabsTrigger>
          </TabsList>
          <TabsContent value="new" className="space-y-4">
            <NewTemplateLists />
          </TabsContent>
          <TabsContent value="spineNew" className="space-y-4">
            <SpineNewTemplateLists />
          </TabsContent>
          <TabsContent value="daily" className="space-y-4">
            <FrameRankingLists kind="daily" />
          </TabsContent>
          <TabsContent value="total" className="space-y-4">
            <FrameRankingLists kind="total" />
          </TabsContent>
          <TabsContent value="avatarNew" className="space-y-4">
            <AvatarRedisLists kind="new" />
          </TabsContent>
          <TabsContent value="avatarDaily" className="space-y-4">
            <AvatarRedisLists kind="daily" />
          </TabsContent>
          <TabsContent value="avatarSimple" className="space-y-4">
            <AvatarRedisLists kind="simple" />
          </TabsContent>
          <TabsContent value="spine" className="space-y-4">
            <TemplateLists listType="spine" />
          </TabsContent>
          <TabsContent value="christmas" className="space-y-4">
            <TemplateLists listType="christmas" />
          </TabsContent>
          <TabsContent value="outfit" className="space-y-4">
            <TemplateLists listType="outfit" />
          </TabsContent>
        </Tabs>
      </div>
    </>
  )
}

export default Index
